import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toggleFilter} from '../../actions/filters';

class FilterButton extends Component {
  componentDidMount() {
    $(this.labelWrap).tooltip({
      container: 'body'
    });
  }

  render() {
    const {isApplied, hasSpotsForFilter, filter, entity} = this.props;

    const labelClassName = () => {
      if (filter === 'All'){
        return "checkbox-tag__all";
      } else if (hasSpotsForFilter) {
        return "checkbox-tag__individual";
      }
      return "checkbox-tag__individual sold-out";
    };

    return (
      <div className="checkbox checkbox-tag">
        <label
          className={labelClassName()}
          ref={(el) => { this.labelWrap = el; }}
          data-toggle={hasSpotsForFilter ? "" : "tooltip"}
          data-placement={hasSpotsForFilter ? "" : "top"}
          title={hasSpotsForFilter ? "" : "No more available"}
          >
          <input type="checkbox"
                 checked={isApplied}
                 onChange={() => {hasSpotsForFilter && this.props.toggleFilter(entity, filter);}}
          />
          <span>
            {filter}
          </span>
        </label>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({toggleFilter}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(FilterButton);



// WEBPACK FOOTER //
// ./src/containers/Search/FilterButton.js